import { Component } from '@angular/core';

@Component({
    selector: 'agmo-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent {
  public displayLoader = false;

  constructor() {}
}
